<template lang="html">
  <section class="wcc section add-to-homescreen" v-if="addToHomescreen">
    <component v-bind:is="component"></component>
  </section>
</template>
<script>
  import Android from './Android/Android.vue'
  import iOS from './iOS/iOS.vue'
  export default {
    data() {
      return {
        platform: null,
        event: null
      }
    },
    computed: {
      addToHomescreen() {
        return this.$store.state.addToHomescreen.show
      },
      component() {
        if (this.$platform.os.family == 'Android') {
          return Android
        } else if (this.$platform.os.family == 'iOS') {
          return iOS
        } else {
          return null
        }
      }
    },
    components: {
      Android,
      iOS
    }
  }
</script>
<style lang="scss">
</style>